export default "__VITE_ASSET__BdHPH5al__"